module.exports = __webpack_public_path__ + "static/media/check_will.d4686725.png";